// angular
//   .module("HeroPRO")
//   .controller("ProductSearchController",

import './productSearch.scss';

/* @ngInject */
export default function ProductSearchController($scope, $sce, $location, $timeout, $stateParams, $anchorScroll, $window, $rootScope, productLookupService, orderByFilter, raSpinnerService, productFilterService, categoryCacheService, geoStateCacheService) {
    /*
       *  Overview
       *
       *  Search is driven by the URL by two main parts the query and the filters. When the URL changes then a new search will be triggered.
       *  Running everything from the URL is required to allow for deep linked search results.
       *
       */

    const vm = this;

    vm.searchTerms = $location.search().query ? $location.search().query : '';
    vm.enteredSearchTerm = vm.searchTerms;
    vm.productTypeId = $stateParams.Id.split('_')[0];
    vm.productGeoState = null;
    vm.productSearchResults = null;
    vm.PagingIndex = 0;
    vm.foundCount = 0;
    vm.pagingCount = 0;
    vm.pagingSize = 20;
    vm.lastPage = null;
    vm.filtersActive = $location.search().filters !== '';// ? true : false;
    vm.filters = null;
    vm.showPageWrapSpinner = true;
    vm.resultsPending = false;
    vm.productTypeNamePlural = null;
    vm.productTypeStateGeos = null;
    vm.setupComplete = false;
    vm.showSelectAttributePopup = false;


    vm.sortOptions = [];

    vm.selectedSort = null;

    vm.switchSort = function (i) {
        vm.selectedSort = vm.sortOptions[i];
        productSearch();
    };


    // Highlighting search results to match the search query
    vm.highlight = function (text) {
        if (!vm.enteredSearchTerm) {
            return $sce.trustAsHtml(text);
        }
        // return $sce.trustAsHtml(text.replace(new RegExp(vm.enteredSearchTerm, 'gi'), '<span class="highlight-text">$&</span>'));
        RegExp.quote = function (str) { return (`${str}`).replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); };
        return $sce.trustAsHtml(decodeURI(encodeURI(text).replace(new RegExp(RegExp.quote(vm.enteredSearchTerm), 'gi'), '<span class="highlight-text">$&</span>')));
    };

    // Initiate new search, resets filters
    vm.productSearchButton = function () {
        vm.clearFilters();

        // Cache search term for the text "no products found for xxxx", if we don't cache it binds directly to what the user is typing in the search box
        vm.enteredSearchTerm = angular.copy(vm.searchTerms);

        // Set the search term - initiates the search by changing the URL
        $location.search({ query: vm.searchTerms, filters: '' });
    };

    // paging
    vm.switchPage = function (pageNumber) {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }

        vm.PagingIndex = pageNumber - 1;
        productSearchRequest();
    };

    vm.clearSearchTerms = function () {
    // if (raSpinnerService.isRegistered("productSearchSpinnner")) {
    //    raSpinnerService.show("productSearchSpinnner");
    // }
        if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
            raSpinnerService.show('productSearchNoResultsSpinnner');
        }

        $location.search('query', '');

        vm.enteredSearchTerm = '';
    };

    vm.clearFilters = function () {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }

        $rootScope.$broadcast('productSearchController.filtersCleared');

        // Replace with original data object here and on service
        productFilterService.clearFilterDTOs();
        vm.filters = productFilterService.getFiltersForDisplay();
        vm.filtersActive = false;

        // Remove filters from URL
        $location.search('filters', '');
    };

    // initiate a search, this will reset paging
    function productSearch() {
        if (raSpinnerService.isRegistered('productSearchSpinnner')) {
            raSpinnerService.show('productSearchSpinnner');
        }
        if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
            raSpinnerService.show('productSearchNoResultsSpinnner');
        }

        // set default if nothing is set
        if (typeof $location.search().query === 'undefined') {
            $location.search({ query: '', filters: '' });
        }

        vm.resultsPending = true;

        // Reset Paging
        vm.PagingIndex = 0;
        vm.FoundCount = 0;

        productSearchRequest();
    }

    // search request, is called directly by paging, otherwise called from productSearch();
    function productSearchRequest() {
        vm.productSearchResults = null;
        vm.searchTerms = $location.search().query;

        const request = {
            GeoState: geoStateCacheService.getCurrentStateObject().StateAbbreviation,
            ProductTypeId: vm.productTypeId,
            SearchTerms: $location.search().query,
            PagingIndex: vm.PagingIndex,
            SortOrder: vm.selectedSort ? vm.selectedSort.SortOrder : null,
            SortKey: vm.selectedSort ? vm.selectedSort.SortKey : null,
            /* global atob */
            Filters: productFilterService.getFiltersForSearchRequest(atob($location.search().filters)),
        };

        const searchPromise = productLookupService.getProductSearch(request);

        searchPromise.then((response) => {
            vm.showPageWrapSpinner = false;
            vm.resultsPending = false;
            vm.productSearchResults = response.data.Products;
            vm.foundCount = response.data.FoundCount;
            vm.pagingCount = response.data.FoundCount > 10000 ? 10000 : response.data.FoundCount;
            vm.lastPage = vm.pagingCount / vm.pagingSize;
            vm.returnedFilters = response.data.FilterOptionResults;

            vm.sortOptions = response.data.ProductSearchSortLabels;

            if (vm.selectedSort === null) {
                vm.selectedSort = vm.sortOptions[0];
            }


            productFilterService.setupFilterOptions(response.data.FilterOptionResults);
            vm.filters = productFilterService.getFiltersForDisplay();
        }, (reason) => {
            $window.alert(`Search Failed: ${reason}`);
        }).finally(() => {
            if (raSpinnerService.isRegistered('productSearchSpinnner')) {
                raSpinnerService.hide('productSearchSpinnner');
            }
            if (raSpinnerService.isRegistered('productSearchNoResultsSpinnner')) {
                raSpinnerService.hide('productSearchNoResultsSpinnner');
            }
            if (raSpinnerService.isRegistered('productSearchResultsSpinnner')) {
                raSpinnerService.hide('productSearchResultsSpinnner');
            }
        });
    }

    // gets the query string parameter for the filtery query string
    function pushFiltersToURL() {
        const filterStringsForURL = productFilterService.getFilterStringsForURL();

        if (filterStringsForURL.length > 0) {
            /* global btoa */
            $location.search('filters', btoa(filterStringsForURL.join('|')));
        } else {
            $location.search('filters', '');
        }
    }

    // setup complete is called after filters and state geos are loaded
    $scope.$on('productCenter.setupComplete', () => {
        const productType = categoryCacheService.getProductTypeByProductTypeId(vm.productTypeId);
        vm.productTypeNamePlural = productType.NamePlural;
        vm.specifications = $sce.trustAsHtml(productType.Specifications);
        vm.productTypeStateGeos = productType.StateGeos; // todo : Fix Name... StateGeos
        vm.productGeoState = geoStateCacheService.getCurrentStateObject().StateAbbreviation;

        // Get the filters for a given product type
        const promise = productLookupService.getProductFilters(vm.productTypeId);
        promise.then((response) => {
            productFilterService.setupFilterDTOs(response.data.SearchFilters);
            vm.filters = productFilterService.getFiltersForDisplay();
        }, (reason) => {
            $window.alert(`Get Filters for Search failed: ${reason}`);
        });
    });

    // shows the modal to select attribute options
    $scope.$on('searchFilters.showOptionsPopup', () => {
        vm.showSelectAttributePopup = true;
    });

    $scope.$on('optionsPopupController.popupShown', () => {
        // required to allow popup to completely load to compare size to window height
        $timeout(() => {
            resizePopup();
        });
    });


    // once filters are loaded, setup is completed and the initial search can occur
    $scope.$on('searchFiltersDirective.filtersLoaded', () => {
        if (!vm.setupComplete) {
            productSearch();
            vm.setupComplete = true;
        }
    });

    // this shouldn't be necessary but was added in order to control the location change event not properly being cleared when controller is removed from DOM
    $scope.$on('$destroy', () => {
        vm.setupComplete = false;
    });

    $scope.$on('searchFiltersGenerator.processFilter', () => {
        pushFiltersToURL();
    });

    $rootScope.$on('optionsPopupController.applyOptions', () => {
        pushFiltersToURL();
    });

    // handles when the url changes to run the search
    $rootScope.$on('$locationChangeSuccess', () => {
        // This is to prevent the $locationChange event from triggering on other pages, however it shouldn't be. When the page is removed
        // from the DOM it should remove its events. For some reason that is not happening????

        if (vm.setupComplete && $location.$$path.indexOf('product-lookup/search') !== -1) {
            productSearch();
            vm.filtersActive = $location.search().filters !== '';
            vm.productGeoState = geoStateCacheService.getCurrentStateObject().StateAbbreviation;
        }
    });

    function resizePopup() {
    /* jshint ignore:start */
    // If popup is visible
        if (angular.element(document.querySelector('.popup'))[0]) {
            console.log('resize');

            const popupBottom = angular.element(document.querySelector('.attribute-popup .popup'))[0].getBoundingClientRect().bottom;
            const windowHeight = window.innerHeight;

            // If popup is taller than the window
            if (popupBottom > windowHeight) {
                angular.element(document.querySelector('.attribute-popup')).addClass('short-window');
            } else {
                // angular.element(document.querySelector('.attribute-popup')).removeClass('short-window');
            }

            // manuall $digest required as resize event
            // is outside of angular
            // scope.$digest();
        }
    /* jshint ignore:end */
    }

    /* jshint ignore:start */
    angular.element(window).bind('resize', () => {
        resizePopup();
    });
    /* jshint ignore:end */
}




// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/productSearchController.js